import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%
`;

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  color: "#fff";
  padding: 0 1rem;
`;

export const Thumb = styled.img`
  max-width: 250px;
  border-radius: 10px;
`;

export const Title = styled.h2`
  margin: 0;
  text-align: center;
`;

export const Author = styled.span`
  color: ${(props) => props.theme.palette.gray[500]};
  text-align: center;
`;

export const ProgressContent = styled.div`
  display: flex;
  justify-content: space-between;
  color: ${({ theme }) => theme.palette.gray[600]};
  font-size: 14px;
  padding: 0 6rem;
  margin-top: 1rem;
`;

export const ProgressFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
`;
